import styled from "styled-components";

export const AccessContainer = styled.div`
  width: 100vw;
  height: 100vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    ${({ theme }) => theme.colors["gradient-deg"]},
    ${({ theme }) => theme.colors["gradient-primary"]} 0%,
    ${({ theme }) => theme.colors["gradient-secondary"]} 100%
  );
`;